jQuery(document).ready(function ($) {
  'use strict';

  // Load More Service Provider
  $('#load-more-service-provider').on('click', function (e) {
    e.preventDefault();

    const button = $(this);
    const currentPage = parseInt(button.data('page'));
    const postsPerPage = parseInt(button.data('posts-per-page'));

    // Get current search and sort parameters from URL
    const urlParams = new URLSearchParams(window.location.search);
    const keyword = urlParams.get('keyword') || '';
    const sort = urlParams.get('sort') || '';

    // Disable button and show loading state
    button.prop('disabled', true);
    button.find('span').text('Loading...');

    $.ajax({
      url: window.ajax_callback_data.ajax_url, // This will be localized from WordPress
      type: 'POST',
      data: {
        action: 'load_more_saved_service_provider',
        page: currentPage,
        posts_per_page: postsPerPage,
        keyword: keyword,
        sort: sort,
        nonce: window.ajax_callback_data.ajax_nonce,
      },
      success: function (response) {
        if (response.success && response.data.html) {
          // Append new items to the container
          $('#service-items').append(response.data.html);
          document.dispatchEvent(new CustomEvent('dv:content-updated'));

          // Update page number
          button.data('page', currentPage + 1);

          // Re-enable button
          button.prop('disabled', false);
          button.find('span').text('Load More');

          // Hide button if no more posts
          if (!response.data.has_more) {
            button.fadeOut();
          }
        } else {
          // No more posts or error
          button.fadeOut();
        }
      },
      error: function (xhr, status, error) {
        console.error('AJAX Error:', error);
        button.prop('disabled', false);
        button.find('span').text('Load More');
        alert('An error occurred. Please try again.');
      },
    });
  });
});
